import { GetApiClient, PostApiClient, DeleteApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

type GetDocumentResponse = DataSchema.Document;
type GetDocumentGoodResponse = DataSchema.DocumentGood;

export const getDocumentApi = (apiClient: GetApiClient, documentId: string) => {
  return apiClient.get<GetDocumentResponse>(`/api/documents/${encodeURIComponent(documentId)}`);
};

export const getDocumentGoodApi = (apiClient: GetApiClient, documentId: string) => {
  return apiClient.get<GetDocumentGoodResponse>(`/api/documents/${encodeURIComponent(documentId)}/good`);
};

export const postDocumentGoodApi = (apiClient: PostApiClient, documentId: string) => {
  return apiClient.post(`/api/documents/${encodeURIComponent(documentId)}/good`, {
    body: JSON.stringify({}), // NOTE: bodyデータを指定しないとエラーになるので、指定
  });
};

export const deleteDocumentGoodApi = (apiClient: DeleteApiClient, documentId: string) => {
  return apiClient.del(`/api/documents/${encodeURIComponent(documentId)}/good`);
};
